import HeroBanner from "./HeroBanner";
import MobileHeroSection from "./MobileHeroSection";
import ServicesGrid from "./ServicesGrid";
import WhyChooseUs from "./WhyChooseUs";
import CaseStudyBanner from "./CaseStudyBanner";
import IndustriesWeServe from "./IndustriesWeServe";
import TestimonialsAndCTA from "./TestimonialsAndCTA"; 

export default function Home() {
  return (
    <>
      <HeroBanner />
      <MobileHeroSection />
      <ServicesGrid/>
      <WhyChooseUs/>
      <IndustriesWeServe/>
      <CaseStudyBanner/>
      <TestimonialsAndCTA/>
    </>
  );
}